import { TriangleAlert } from 'lucide-react';
import {Cellule} from "../../../../types/cellule";
import {useDisclosure} from "@mantine/hooks";
import React, {forwardRef, ReactElement, useEffect, useState} from "react";
import {
    CloseButton,
    Group,
    Modal,
} from "@mantine/core";
import "./modale_configurer_cellule.scss"

export function Modale_configurer_cellule_mobile({cellule, forcer, children}:
                                                 {
                                                     cellule: Cellule,
                                                     forcer: boolean,
                                                     children: ReactElement, etape?: number
                                                 }) {
    const [opened, {open, close}] = useDisclosure(forcer);

    return (
        <>
            <Modal opened={opened} onClose={close} withCloseButton={false}
                   className={"padding_bottom_modale_quand_boutons_fixed mesure_config_modale modale-fullscreen"}
                   closeOnClickOutside={!forcer && cellule.nom !== "Nouvelle cellule"}
            >
                <div className={"modal-en-tete-custom"}>
                    <p className="titre">Configurer la cellule</p>

                    <Group justify="center">
                        <CloseButton aria-label="Fermer la fenetre" onClick={() => {

                            close();

                        }}/>
                    </Group>
                </div>

                <p className={"notice grey"}>
                    <TriangleAlert />
                    La configuration des cellules n'est pas disponible depuis l'application mobile.
                    Merci de vous rendre sur <a href="https://app.freshtime.fr">https://app.freshtime.fr</a> depuis votre navigateur pour accéder à cette fonctionnalité. Merci.
                </p>

            </Modal>

            <button className={"sec"} onClick={open}>{children}</button>


        </>
    );
}